/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable import/first */
// Entry point for the feed.web.js bundle, this is the first JS from our app that runs
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import {
    Dedupe as DedupeIntegration,
    ExtraErrorData as ExtraErrorDataIntegration,
} from '@sentry/integrations';

const shouldUseSentry = !process.env.IS_CYPRESS_RUN;

function getEnv(host = 'evbdev.com:8082') {
    if (host.indexOf('eventbrite') > -1) {
        return 'production';
    }

    if (host.indexOf('evbqa') > -1) {
        return 'qa';
    }

    if (host.indexOf('evbstage') > -1) {
        return 'stage';
    }

    return 'dev';
}

if (shouldUseSentry) {
    Sentry.init({
        dsn:
            'https://9a651a886d0d43a79d58cdcefa083e97@o375540.ingest.sentry.io/5474383',
        integrations: [
            new Integrations.BrowserTracing(),
            new DedupeIntegration(),
            new ExtraErrorDataIntegration(),
        ],

        // https://sentry.io/eventbrite-eng/consumer-frontend/getting-started/javascript-react/
        tracesSampleRate: 0.1,
        release: process.env.FEED_VERSION,
        environment: getEnv(window.location.host),
    });

    if (window.__SERVER_DATA__.user.email) {
        const sentryUser = {
            email: window.__SERVER_DATA__.user.email,
            id: window.__SERVER_DATA__.user.publicId,
        };

        // MUST have one of email, id, username, or ip to call setUser()
        Sentry.setUser(sentryUser);
    }

    if (window.__SERVER_DATA__.guest_id) {
        Sentry.setTag('guest_id', window.__SERVER_DATA__.guest_id);
    }

    Sentry.setTag('page_locale', window.__i18n__.locale);
}

// These are the minimum polyfills so that legacy browsers can
// dynamically import
import 'core-js/modules/es.promise';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.array.includes';

// Always polyfill generators because we can't reliably detect
// generator support in browser
import 'regenerator-runtime/runtime';

// polyfill requestAnimationFrame for old browsers
import 'raf/polyfill';

import featureDetect from 'feature-detect-es6';

import './index.scss';
import './EdsOverrides.scss';

// Sometimes dynamic imports fail on slow connections
// For now just silence the errors to stop sending (there are too many)
// eslint-disable-next-line func-style
function genericDynamicImportErrorHandler(err) {
    if (process.env.NODE_ENV !== 'production') {
        throw err;
    }
    return null;
}

// These CSS imports we still want, but do a dynamic import here so they are
// not included in the first bundle, they get loaded asyncronously
import('@eb/eds-css/src/eds.scss').catch(genericDynamicImportErrorHandler);

if (featureDetect.all('class', 'spread', 'let', 'arrowFunction')) {
    import('./index.post').catch(genericDynamicImportErrorHandler);
} else {
    // Only load core-js polyfill if needed, it's big
    // Todo: split this out to exclude the ones we already imported
    import('core-js/stable')
        .then(() =>
            import('./index.post').catch(genericDynamicImportErrorHandler),
        )
        .catch(genericDynamicImportErrorHandler);
}
